import { 
    QueryClient, 
    QueryClientProvider, 
    useQuery, 
    useMutation,
    QueryErrorResetBoundary
  } from '@tanstack/react-query';
  import { ErrorBoundary } from 'react-error-boundary';
  import { Alert, Button, CircularProgress, Typography } from '@mui/material';
  
  // Create a client
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1, // Only retry once by default
        refetchOnWindowFocus: false // Disable refetching on window focus
      }
    }
  });
  
  // Error fallback component
 export const ErrorFallback = ({ error, resetErrorBoundary }: {error: Error, resetErrorBoundary: any}) => (
    <Alert 
      severity="error" 
      action={
        <Button color="inherit" size="small" onClick={resetErrorBoundary}>
          Try Again
        </Button>
      }
    >
      <Typography variant="subtitle1">Error: {error.message}</Typography>
    </Alert>
  );
  
